import React from 'react';
import phoneImg from '../../assets/images/feature2.webp';
import './guidancesection.css';

const GuidanceSection = () => {
  return (
    <section className="guidancesection-section">
      <div className="guidancesection-container">
        {/* Left Text Section */}
        <div className="guidancesection-content">
          <p className="guidancesection-title">
            For Life’s Bigger Questions
          </p>
          <h2 className="guidancesection-heading">
            Auspicious Planning
          </h2>
          <p className="guidancesection-description">
            Our live daily panchang helps you find the perfect Shubh Muhurat for travel, career moves, relationships and more.
          </p>
        </div>
        {/* Right Image */}
        <img
          src={phoneImg}
          alt="MyNaksh Mobile Preview"
          className="guidancesection-image"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default GuidanceSection;
